import React from 'react';
const STATS = [{
  value: '300+',
  label: 'Páginas clínicas'
}, {
  value: '6',
  label: 'Tomos especializados'
}, {
  value: '5',
  label: 'Bonos exclusivos'
}, {
  value: 'Acceso',
  label: 'De por vida'
}];
export function Stats() {
  return <section className="w-full border-y border-navy-100 bg-white px-4 py-8 sm:py-10" data-id="element-283" data-mp="2ahd8kzhq98ds">
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-y-6 sm:grid-cols-4" data-id="element-284" data-mp="26h34jsdhws1k">
        {STATS.map(stat => <div key={stat.label} className="flex flex-col items-center px-2 text-center" data-id="element-285" data-mp="334zmb0ko5ted">
            <span className="font-display text-2xl font-bold leading-none text-navy-900 sm:text-3xl" data-id="element-286" data-mp="2y7hdda6nje6d">
              {stat.value}
            </span>
            <span className="mt-1.5 text-[10.5px] font-semibold uppercase tracking-[0.12em] text-navy-400 sm:text-[11px]" data-id="element-287" data-mp="2p69ofiq0zpoy">
              {stat.label}
            </span>
          </div>)}
      </div>
    </section>;
}